import __vue_component__$1 from '../Button/Button.vue.js';
import __vue_component__ from '../Checkbox/Checkbox.vue.js';

//
var script = {
  components: {
    Checkbox: __vue_component__,
    Button: __vue_component__$1
  },
  model: {
    prop: 'checked',
    event: 'input'
  },
  props: {
    checked: {
      type: [Boolean, Array],
      required: true
    },
    value: {
      type: String,
      default: undefined
    },
    showOnlyButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isMulti() {
      return Array.isArray(this.checked) && this.value;
    }

  },
  methods: {
    onInput(value) {
      this.$emit('input', value);
    },

    onOnlyClicked() {
      this.$emit('input', [this.value]);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Dropdown/DropdownCheckboxItem.vue_rollup-plugin-vue=script.js